import Ajax from "../../lib/ajax";
import util from "../../lib/util";
import BillingAccount from "../entities/billingAccount";
import JoinedGroup from "../entities/joinedGroup";
import inviteNotification from "../entities/inviteNotification";
import PricePlan from "../entities/price-plan";
import { Store, Module, ActionContext } from "vuex";

interface BillingState {
  loading: boolean;
  billingAccount: BillingAccount;
  currentMemberJoinedGroups: JoinedGroup[];
  noticeSpinShow: boolean;
  inviteNotifications: inviteNotification[];
  noticeList: any[];
  pricePlans: PricePlan[];
}

class BillingStore implements Module<BillingState, any> {
  namespaced = true;
  state = {
    loading: false,
    billingAccount: null,
    currentMemberJoinedGroups: new Array<JoinedGroup>(),
    noticeSpinShow: false,
    inviteNotifications: new Array<inviteNotification>(),
    pricePlans: [],
    noticeList: []
  };
  getters = {
    inviteMessage: (state, getters) => {
      return "I would like to invite you to join me in my GOATSUCCESS account. GOATSUCCESS will be our vehicle to master new skills, build good habits, improve processes, expand capabilities, and achieve GOAT success.";
    },
    hasUserManagementPermission: (state, getters) => {
      let account = state.billingAccount;
      if (account && account.members.length > 0) {
        const currentUser = account.members.find(m => m.memberId === abp.session.userId);
        return currentUser && (currentUser.role === 1 || currentUser.role === 2);
      }
      return false;
    },
    hasAccountAdminPermission: (state, getters) => {
      let account = state.billingAccount;
      return account && account.grantedPermissions && account.grantedPermissions.includes("Bio.Adminland");
    },
    activeUsers: (state, getters) => {
      let members = state.billingAccount && state.billingAccount.members ? state.billingAccount.members.filter(m => m.licenseAssigned === true) : [];
      return members;
    },
    currentBillingAccountInviteRoles: (state, getters) => {
      let results = [];
      results.push({
        value: 3,
        name: "member",
        title: "User",
        description: "No manager permissions."
      });

      results.push({
        value: 2,
        name: "leader",
        title: "Manager",
        description: "Can add and remove users from account. Can see all user's priorities and activities in the account. Can change what user's can access in the account."
      });

      // results.push({
      //   value: 1,
      //   name: "admin",
      //   title: "Account Owner",
      //   disabled: true,
      //   description: "Can access and manage the entire account, including users and billing settings."
      // });

      return results;
    }
  };
  actions = {
    async createSession(context: ActionContext<BillingState, any>, payload: any) {
      return await Ajax.post("/api/services/app/Billing/CreateSession", payload.option);
    },
    async getInvoices(context: ActionContext<BillingState, any>) {
      return await Ajax.get("/api/services/app/Billing/GetInvoices");
    },
    async getBillingAccountInfo(context: ActionContext<BillingState, any>, payload: any) {
      context.state.loading = true;
      await Ajax.get("/api/services/app/Billing/GetBillingAccountInfo").then(response => {
        context.state.billingAccount = response.data.result as BillingAccount;
      });
      context.state.loading = false;

      return context.state.billingAccount;
    },
    async getJoinedGroups(context: ActionContext<BillingState, any>, payload: any) {
      context.state.loading = true;
      return Ajax.get(`/api/services/app/Billing/GetJoinedGroups?MemberId=${payload.data.memberId}`)
        .then(response => {
          context.state.currentMemberJoinedGroups = response.data.result as JoinedGroup[];
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
    async updateInvoiceEmail(context: ActionContext<BillingState, any>, payload: any) {
      context.state.loading = true;
      await Ajax.put("/api/services/app/Billing/UpdateInvoiceEmail", payload.data).then(response => {
        context.state.billingAccount = Object.assign(response.data.result.billingAccount as BillingAccount, {
          grantedPermissions: context.state.billingAccount.grantedPermissions
        });
      });
      context.state.loading = false;

      return context.state.billingAccount;
    },
    async renameAccount(context: ActionContext<BillingState, any>, payload: any) {
      context.state.loading = true;
      await Ajax.post("/api/services/app/Billing/RenameAccount", payload.data).then(response => {
        context.state.billingAccount = Object.assign(response.data.result.billingAccount as BillingAccount, {
          grantedPermissions: context.state.billingAccount.grantedPermissions
        });

        context.dispatch("session/init", null, { root: true });
        //util.abp.custom.billingAccounts = response.data.result.joinedBillingAccounts;
      });
      context.state.loading = false;

      return context.state.billingAccount;
    },
    async assignLicense(context: ActionContext<BillingState, any>, payload: any) {
      context.state.loading = true;
      return Ajax.post("/api/services/app/Billing/AssignLicense", payload.data)
        .then(response => {
          context.state.billingAccount = Object.assign(response.data.result.billingAccount as BillingAccount, {
            grantedPermissions: context.state.billingAccount.grantedPermissions
          });
          //context.dispatch("session/init", null, { root: true });
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
    async removeLicense(context: ActionContext<BillingState, any>, payload: any) {
      context.state.loading = true;
      return Ajax.delete(`/api/services/app/Billing/RemoveLicense?MemberId=${payload.data.memberId}`)
        .then(response => {
          context.state.billingAccount = Object.assign(response.data.result.billingAccount as BillingAccount, {
            grantedPermissions: context.state.billingAccount.grantedPermissions
          });
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
    async changeAccountOwner(context: ActionContext<BillingState, any>, payload: any) {
      context.state.loading = true;
      return Ajax.post("/api/services/app/Billing/ChangeAccountOwner", payload.data)
        .then(response => {
          context.state.billingAccount = Object.assign(response.data.result.billingAccount as BillingAccount, {
            grantedPermissions: context.state.billingAccount.grantedPermissions
          });
          //context.dispatch("session/init", null, { root: true });
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
    async updateCreditCard(context: ActionContext<BillingState, any>, payload: any) {
      context.state.loading = true;
      return Ajax.put(`/api/services/app/Billing/UpdateCreditCard?paymentMethodId=${payload.paymentMethodId}`)
        .then(response => {
          if (response.data.result.success === true) {
            context.state.billingAccount.lastPaymentMethod = (response.data.result.billingAccount as BillingAccount).lastPaymentMethod;
          }

          return response;
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
    async updateSubscription(context: ActionContext<BillingState, any>, payload: any) {
      context.state.loading = true;
      return Ajax.put("/api/services/app/Billing/UpdateSubscription", payload.data)
        .then(response => {
          if (response.data.result.success === true) {
            context.state.billingAccount = response.data.result.billingAccount as BillingAccount;
          }

          return response;
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
    async cancelAccount(context: ActionContext<BillingState, any>, payload: any) {
      context.state.loading = true;
      return Ajax.post("/api/services/app/Billing/CancelAccount", payload)
        .then(response => {
          context.state.billingAccount = Object.assign(response.data.result.billingAccount as BillingAccount, {
            grantedPermissions: context.state.billingAccount.grantedPermissions
          });
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
    async withdrawCancellation(context: ActionContext<BillingState, any>, payload: any) {
      context.state.loading = true;
      return Ajax.post("/api/services/app/Billing/WithdrawCancellation")
        .then(response => {
          context.state.billingAccount = Object.assign(response.data.result.billingAccount as BillingAccount, {
            grantedPermissions: context.state.billingAccount.grantedPermissions
          });
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
    async acceptInvitation(context: ActionContext<BillingState, any>, payload: any) {
      return Ajax.post("/api/services/app/Billing/AcceptInvitation", payload);
    },
    async inviteMember(context: ActionContext<BillingState, any>, payload: any) {
      return Ajax.post("/api/services/app/Billing/InviteMember", payload.data);
    },
    async updateMember(context: ActionContext<BillingState, any>, payload: any) {
      return Ajax.put("/api/services/app/Billing/UpdateMember", payload.data);
    },
    async sendLoginUrl(context: ActionContext<BillingState, any>, payload: any) {
      return Ajax.post("/api/services/app/Billing/SendLoginUrl", payload.data);
    },
    async requestMoreLicenses(context: ActionContext<BillingState, any>, payload: any) {
      return Ajax.post("/api/services/app/Billing/RequestMoreLicenses", payload.data);
    },
    async getPricePlans(context: ActionContext<BillingState, any>, payload: any) {
      return Ajax.get("/api/services/app/Billing/GetPricePlans").then(response => {
        context.state.pricePlans = response.data.result;
      });
    },
    async updateSubscriptionPreview(context: ActionContext<BillingState, any>, payload: any) {
      return Ajax.put("/api/services/app/Billing/UpdateSubscriptionPreview", payload.data);
    },
    async getInviteNotifications(context: ActionContext<BillingState, any>, payload: any) {
      context.state.noticeSpinShow = true;
      await Ajax.get("/api/services/app/BillingAccountInvitation/GetInviteNotifications")
        .then(response => {
          context.state.inviteNotifications = response.data.result;
          context.state.noticeList = context.state.inviteNotifications.map(invitation => {
            return {
              type: 0,
              read: false,
              title: `Join "${invitation.accountName}"`,
              description: `From ${invitation.inviterName}`,
              invitation: invitation
            };
          });
        })
        .finally(() => {
          context.state.noticeSpinShow = false;
        });
    },
    async changeMyUserListColumns(context: ActionContext<BillingState, any>, payload: any) {
      let result = null;
      await Ajax.post("/api/services/app/Configuration/ChangeMyUserListColumns", payload).then(response => {
        result = response;
      });

      return result;
    },
    async changeMyTeamPriorityListColumns(context: ActionContext<BillingState, any>, payload: any) {
      let result = null;
      await Ajax.post("/api/services/app/Configuration/ChangeMyTeamPriorityListColumns", payload).then(response => {
        result = response;
      });

      return result;
    },
    async changeMyUserPriorityListColumns(context: ActionContext<BillingState, any>, payload: any) {
      let result = null;
      await Ajax.post("/api/services/app/Configuration/ChangeMyUserPriorityListColumns", payload).then(response => {
        result = response;
      });

      return result;
    }
  };
}
export default new BillingStore();
